export default __webpack_public_path__ + "static/media/Railway Station - Namangan.d27ed90d.jpg";